// extracted by mini-css-extract-plugin
export default {"main":"_9a054e298b e1a1e194d8","xmark":"_480394231c","fl_img":"_3e9bdb06f1 _847ca18a7a"};